import { Box } from "@mui/material";

const DiscountCard: React.FC = () => {
  return (
    <Box
      draggable="false"
      component="img"
      src="/imgs/discount_card.png"
      alt="Discount Card"
      sx={{
        position: "fixed", // ✅ stays in place even when scrolling
        width: "203.218px",
        height: "102.014px",
        top: "720.31px",
        left: 50,
        opacity: 1,
        transform: "rotate(0deg)",
        objectFit: "contain",
        display: { xs: "none", md: "block" }, // ✅ hide on mobile
        transition: "transform 0.3s ease-in-out",
        zIndex: 9999, // ✅ keeps it above all content
        "&:hover": {
          transform: "scale(1.08)",
          cursor: "pointer",
        },
      }}
      onClick={() => {
        window.open("https://t.me/addlist/99uO9eak4w03OGZl", "_blank", "noopener,noreferrer");
      }}
    />
  );
};

export default DiscountCard;
